// Helpers for the Google OAuth callback (authorization-code flow).
// Google redirects back to {origin}/auth/google?code=...; we read the code and
// hand it to the backend which exchanges it (client_secret stays server-side).
export function getGoogleCodeFromUrl() {
  return new URLSearchParams(window.location.search || "").get("code");
}

export function isGoogleCallbackPath() {
  return typeof window !== "undefined" && window.location.pathname === "/auth/google";
}
